import { RovoLogo } from '@atlaskit/logo';
import { ConfluenceBackground } from '@atlassian/product-wireframes';
import { CobrandingComponents } from '../shared-cobranding';

const RovoCobranding: CobrandingComponents = {
  background: ConfluenceBackground,
  logo: { component: RovoLogo },
  footerProducts: 'Confluence, Jira, Trello',
};

export default RovoCobranding;
